<template>
    <div class="filtros-extras">
        <b-collapse class="card" :open="false">
            <div slot="trigger" slot-scope="props" class="card-header is-paddingless">
                <div class="card-header-title">
                    <div class="filtro-header">
                        <b-icon :icon="props.open ? 'menu-down' : 'menu-right'"></b-icon>
                        {{ $t('filtros') }}
                    </div>
                </div>
            </div>
            <div class="card-content">
                <div class="columns is-multiline py-2">
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <label>{{ $t('cliente') }}</label>
                        <vss-select
                            placeholder="todos"
                            :value="filter.cliente"
                            label="rsocial"
                            :options="clientes"
                            :select-height="40"
                            :loading="clientesLoading"
                            @input="updateCliente"
                            @search="carregarClientes"
                            searchable
                            clearable
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <label>{{ $t('propriedade') }}</label>
                        <vss-select
                            placeholder="todos"
                            v-model="filter.propriedade"
                            :options="propriedades"
                            label="nome"
                            :select-height="40"
                            @input="updatePropriedade"
                            :loading="propriedadeLoading"
                            @search="carregarPropriedades"
                            searchable
                            clearable
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <label>{{ $t('motivo') }}</label>
                        <vss-select
                            placeholder="todos"
                            v-model="filter.motivo"
                            label="descricao"
                            :options="motivos"
                            :select-height="40"
                            :loading="motivosLoading"
                            @input="updateMotivo"
                            @search="carregarMotivos"
                            searchable
                            clearable
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <label>{{ $t('possui-foto-atendimento') }}</label>
                        <vss-select
                            v-model="possuiFotoAtendimento"
                            :options="possuiOpcoes"
                            :selectHeight="40"
                            @input="updateOpcoes($event, 'fotoAtendimento')"
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <label>{{ $t('possui-agro-visita') }}</label>
                        <s-select
                            v-model="possuiRtr"
                            :options="possuiOpcoes"
                            :selectHeight="40"
                            @input="updateOpcoes($event, 'rtr')"
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <label>{{ $t('possui-foto-agro-visita') }}</label>
                        <vss-select
                            v-model="possuiFotoRtr"
                            :options="possuiOpcoes"
                            :selectHeight="40"
                            @input="updateOpcoes($event, 'fotoRtr')"
                            :disabled="controleFotoRtr"
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <label>{{ $t('vendedores') }}</label>
                        <vss-select
                            v-model="filter.vendedores"
                            :value="vendedoresSelecionados"
                            :options="vendedores"
                            :selectHeight="40"
                            :loading="vendedoresLoading"
                            @search="carregarVendedores"
                            @input="updateVendedor"
                            label="nome"
                            multiple
                            searchable
                            clearable
                        />
                    </div>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import AtendimentoAgricolaService from '@/services/AtendimentoAgricolaService';
import VendasClienteService from '@/services/VendasClienteService';
import MotivoAtendimentoService from '@/services/MotivoAtendimentoService';
import ColaboradorService from '@/services/ColaboradorService';
import PropriedadeService from '@/services/agro/PropriedadeService';
/********* exportação *********/
import ExportacaoTipoService from '@/services/ExportacaoTipoService';
import ExportacaoService from '@/services/ExportacaoService';
import ExportacaoLogService from '@/services/ExportacaoLogService';

/**
 * @deprecated Essa classe foi depreciada e nao devera ser usada
 */
export default {
    data() {
        return {
            atendimentos: [],
            service: new AtendimentoAgricolaService(this.$http, this.$router),
            clienteService: new VendasClienteService(this.$http, this.$router),
            motivoService: new MotivoAtendimentoService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router), // vendedor
            propriedadeService: new PropriedadeService(this.$http, this.$router),
            /********* exportação *********/
            exportacaoTipoService: new ExportacaoTipoService(this.$http, this.$router),
            // cultivarService: new CultivarService(this.$http, this.$router),
            // culturaService: new CulturaService(this.$http, this.$router),
            exportacaoService: new ExportacaoService(this.$http, this.$router),
            exportacaoLogService: new ExportacaoLogService(this.$http, this.$router),
            fields: [
                {
                    key: 'idatendimentoagricola',
                    label: 'codigo',
                    sortable: true,
                    centered: true,
                    width: 100,
                },
                {
                    key: 'motivo',
                    label: 'motivo',
                    sortable: true,
                    width: '20%',
                },
                {
                    key: 'cliente',
                    label: 'cliente',
                    sortable: true,
                    width: '30%',
                },
                {
                    key: 'propriedade',
                    label: 'propriedade',
                    sortable: true,
                    width: '30%',
                },
                {
                    key: 'hasRtr',
                    label: '',
                    sortable: false,
                    centered: true,
                },
            ],
            filter: {
                datainicial: null,
                datafinal: null,
                cliente: null,
                motivo: null,
                possuiFotoAtendimento: null,
                possuiRtr: null,
                possuiFotoRtr: null,
                vendedores: [],
                propriedade: null,
                // cultivar: null,
                // cultura: null,
            },
            tituloExportacao: '',
            exportacao: {},
            nomeTela: 'ATENDIMENTOLISTA',
            exportacaoTipo: {},
            hasAtendimentos: false,
            hasFotosAtendimentos: false,
            hasRtr: false,
            hasFotosRtr: false,
            controleFotoRtr: false,
            controleCultura: false,
            datainicial: null,
            datafinal: null,
            clientes: [],
            // culturas: [],
            // culturasLoading: false,
            // cultivares: [],
            // cultivaresLoading: false,
            clientesLoading: false,
            motivos: [],
            motivosLoading: false,
            vendedores: [],
            showMsgFilters: false,
            showMsgList: false,
            isShowingExport: false,
            isShowingTitle: false,
            vendedoresLoading: false,
            vendedoresSelecionados: [],
            propriedades: [],
            msgs: [],
            propriedadeLoading: false,
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            column: 'datahora',
            order: 'desc',
            modalOpen: false,
            tipoExportacao: '',
            possuiOpcoes: [
                {
                    id: 1,
                    label: 'Sim',
                },
                {
                    id: 2,
                    label: 'Não',
                },
                {
                    id: 0,
                    label: 'Todos',
                },
            ],
            possuiFotoAtendimento: {
                id: 0,
                label: 'Todos',
            },
            possuiRtr: {
                id: 0,
                label: 'Todos',
            },
            possuiFotoRtr: {
                id: 0,
                label: 'Todos',
            },
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
        };
    },
    created() {},
    methods: {
        limparFiltrosSelecionados() {
            this.filter = {
                datainicial: null,
                datafinal: null,
                propriedade: null,
                cliente: null,
                // cultura: null,
                // cultivar: null,
                motivo: null,
                possuiFotoAtendimento: {
                    id: 0,
                    label: 'Todos',
                },
                possuiFotoRtr: {
                    id: 0,
                    label: 'Todos',
                },

                possuiRtr: {
                    id: 0,
                    label: 'Todos',
                },

                vendedores: [],
            };

            this.propriedades = [];
            this.queryFilter = '';
            (this.possuiFotoAtendimento = {
                id: 0,
                label: 'Todos',
            }),
                (this.possuiFotoRtr = {
                    id: 0,
                    label: 'Todos',
                }),
                (this.possuiRtr = {
                    id: 0,
                    label: 'Todos',
                });

            this.controleFotoRtr = false; // para o botão Limpar Filtros funcionar precisa setar como false this.controleFotoRtr e  this.controleCultura
            this.controleCultura = false;
        },

        carregarClientes(q) {
            this.clientesLoading = true;
            this.clienteService
                .listAll(20, q)
                .then((r) => {
                    this.clientes = r.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de clientes. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.clientesLoading = false;
                });
        },
        updateCliente(val) {
            if (
                !val ||
                (val && this.filter && this.filter.cliente && this.filter.cliente.id != val.id)
            ) {
                this.atendimentos.propriedade = {};
                this.filter.propriedade = {};
                this.propriedades = [];
            }

            this.$emit('update-filtro', {
                nomeFiltro: 'cliente',
                valor: val,
            });
            this.filter.cliente = val;
            this.carregarPropriedades();
        },
        updateOpcoes(obj, field) {
            switch (field) {
                case 'fotoRtr':
                    this.$emit('update-filtro', {
                        nomeFiltro: 'possuiFotoRtr',
                        valor: obj,
                    });
                    break;
                case 'fotoAtendimento':
                    this.$emit('update-filtro', {
                        nomeFiltro: 'possuiFotoAtendimento',
                        valor: obj,
                    });
                    break;
                case 'rtr':
                    this.$emit('update-filtro', {
                        nomeFiltro: 'possuiRtr',
                        valor: obj,
                    });

                    if (obj.label == 'Não') {
                        this.filter.possuiFotoRtr = {
                            id: 0,
                            label: 'Todos',
                        };
                        this.possuiFotoRtr = {
                            id: 0,
                            label: 'Todos',
                        };

                        this.controleCultura = true;
                        this.controleFotoRtr = true;
                    } else if (obj.label == 'Sim') {
                        this.controleFotoRtr = false;
                        this.controleCultura = false;
                    } else if (obj.label == 'Todos') {
                        this.controleFotoRtr = false;
                        this.controleCultura = false;
                    }
                    break;

                default:
                    break;
            }
        },
        carregarMotivos(q) {
            this.motivosLoading = true;
            this.motivoService
                .findAll()
                .then((r) => {
                    this.motivos = r.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de motivos. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.motivosLoading = false;
                });
        },
        updateMotivo(e) {
            this.$emit('update-filtro', {
                nomeFiltro: 'motivo',
                valor: e,
            });
        },
        carregarPropriedades(q) {
            if (this.filter && this.filter.cliente && this.filter.cliente.id > 0) {
                this.propriedadesLoading = true;
                this.propriedadeService
                    .listAllByIdCliente(this.filter.cliente.id, 50, 0, q)
                    .then((r) => {
                        let propriedades = [];
                        propriedades[0] = {
                            id: null,
                            nome: 'SEM PROPRIEDADE',
                        };
                        this.propriedades = propriedades.concat(r.content);
                    })
                    .catch((e) => {
                        console.error(
                            `Erro ao realizar pesquisa de propriedades. Termo: [${q}]`,
                            e
                        );
                    })
                    .finally((_) => {
                        this.propriedadesLoading = false;
                    });
            }
        },
        updatePropriedade(e) {
            this.filter.propriedade = e;
            this.$emit('update-filtro', {
                nomeFiltro: 'propriedade',
                valor: e,
            });
        },
        carregarCulturas(q) {
            this.culturasLoading = true;

            this.culturaService
                .findAllCombo(q)
                .then((r) => {
                    this.culturas = r.content.map((e) => {
                        return {
                            idtipocultura: e.idtipocultura,
                            descricao: e.descricao,
                            id: e.id,
                        };
                    });
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de cultura. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.culturasLoading = false;
                });
        },
        /* 
            @87166 - a procedure proc_listagem_atendimentoagricola estava
            com muito gargalo por conta dos LEFT JOINS presentes em cultivar.
            Como atendimento sera refatorado, essa mudanca foi comentada por enquanto
        */

        // updateCultura(cultura) {
        //     this.$emit("update-filtro", {
        //         nomeFiltro: "cultura",
        //         valor: cultura,
        //     });

        //     this.filter.cultura = cultura;
        //     this.filter.cultivar = null;
        //     this.carregarCultivares('');
        // },
        // carregarCultivares(searchQuery) {
        //     if (this.filter.cultura != null) {

        //         this.cultivaresLoading = true;
        //         const idCultura = this.filter.cultura.id;

        //         this.cultivarService
        //             .findAllComboByIdCultura(1, idCultura, searchQuery)
        //             .then((r) => {
        //                 this.cultivares = r.content.map((e) => {
        //                     return {
        //                         idcultivar: e.idcultivar,
        //                         descricao: e.descricao,
        //                         id: e.id,
        //                     };
        //                 });
        //             })
        //             .catch((e) => {
        //                 console.error(
        //                     `Erro ao realizar pesquisa de cultivares. Termo: [${searchQuery}]`,
        //                     e
        //                 );
        //             })
        //             .finally((_) => {
        //                 this.cultivaresLoading = false;
        //             });
        //     }
        // },
        // updateCultivar(cultivar) {
        //     this.$emit("update-filtro", {
        //         nomeFiltro: "cultivar",
        //         valor: cultivar,
        //     });
        // },
        carregarVendedores(q) {
            this.vendedoresLoading = true;

            this.colaboradorService
                .findListAssociated(q)
                .then((r) => {
                    this.vendedores = r.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de vendedores. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.vendedoresLoading = false;
                });
        },
        updateVendedor(vendedoresSelecionados) {
            if (vendedoresSelecionados) {
                this.$emit('update-filtro', {
                    nomeFiltro: 'vendedores',
                    valor: vendedoresSelecionados,
                });
            } else {
                this.filter.vendedores = null;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.card {
    overflow: initial;
    color: $darker-gray-color;
    .card-header-title {
        color: $darker-gray-color;
        justify-content: space-between;
        padding: 0.3rem;
    }

    .card-content {
        padding: 0.9rem;

        .card-content-top {
            padding-top: 0.25rem;
            padding-bottom: 0.25rem;
        }
    }
}

.filtro-header {
    display: flex;
    align-items: center;
}

.filtros-extras {
    font-size: 12px;
}
.form-height {
    height: 34px;
}
</style>
